import { render, staticRenderFns } from "./RenewalRequest.vue?vue&type=template&id=64432c7e&scoped=true&"
import script from "./RenewalRequest.vue?vue&type=script&lang=ts&"
export * from "./RenewalRequest.vue?vue&type=script&lang=ts&"
import style0 from "./RenewalRequest.vue?vue&type=style&index=0&id=64432c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64432c7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VFlex,VImg,VLayout,VSpacer,VTextField})
